<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M196.658 82.1598L196.661 82.1655C198.934 86.5333 204.317 88.2317 208.685 85.9589L234.211 72.6768C238.579 70.404 240.277 65.0208 238.004 60.653L238.001 60.6473C235.728 56.2795 230.345 54.5812 225.977 56.8539L200.452 70.136C196.084 72.4088 194.386 77.792 196.658 82.1598Z"
      class="fill-brand-100"
    />
    <path
      d="M205.856 67.3529C205.856 67.3529 180.352 78.3865 173.901 79.8073C166.752 81.3817 159.206 80.601 152.064 78.9754L106.016 66.5529C99.8593 65.1065 95.5329 64.601 89.6193 64.601C69.5297 64.6074 53.3057 81.0234 53.3057 101.113V183.948C53.3057 186.451 55.3345 188.473 57.8305 188.473H121.472C123.974 188.473 125.997 186.444 125.997 183.948V118.207C125.997 114.483 128.934 111.423 132.653 111.263L155.034 110.31C161.094 110.054 167.046 108.652 172.582 106.182L213.216 83.6473L205.85 67.3466L205.856 67.3529Z"
      class="fill-brand-500"
    />
    <path
      d="M143.782 250.924H48.2432V167.449L126.003 167.807L143.782 250.924Z"
      class="fill-secondary-500"
    />
    <path
      d="M93.6833 202.649H17.1586C15.4626 202.649 14.0802 201.267 14.0802 199.571V150.201C14.0802 148.505 15.4626 147.123 17.1586 147.123H93.6833V202.649Z"
      class="fill-brand-300"
    />
    <path
      d="M80.1409 194.943V155.18C80.1409 153.388 81.2545 151.782 82.9313 151.155L93.6833 147.116V202.643L83.0529 199.014C81.3121 198.419 80.1409 196.78 80.1409 194.943Z"
      class="fill-accent-500"
    />
    <path
      d="M73.7216 179.289C76.157 179.289 78.1312 177.315 78.1312 174.879C78.1312 172.444 76.157 170.47 73.7216 170.47C71.2863 170.47 69.312 172.444 69.312 174.879C69.312 177.315 71.2863 179.289 73.7216 179.289Z"
      class="fill-accent-500"
    />
    <path
      d="M54.656 188.147C54.656 183.159 50.613 179.116 45.6256 179.116C40.6383 179.116 36.5952 183.159 36.5952 188.147V217.279C36.5952 222.267 40.6383 226.31 45.6256 226.31C50.613 226.31 54.656 222.267 54.656 217.279V188.147Z"
      class="fill-brand-100"
    />
    <path
      d="M76.5248 70.6042L75.3408 66.7898C60.5248 67.1546 45.056 74.0858 41.8048 96.4922C41.8048 96.4922 38.1376 119.423 36.3776 130.425C35.7504 134.361 35.4688 138.335 35.5456 142.323L36.5952 194.764L54.6944 194.79L57.4912 142.476L78.8544 74.2842C79.3792 72.601 78.272 70.8474 76.5248 70.6042Z"
      class="fill-brand-500"
    />
    <path
      d="M89.1328 67.7882H103.61V59.9034H89.1328V67.7882Z"
      class="fill-secondary-500"
    />
    <path
      d="M122.4 38.9561C121.594 37.6569 117.702 34.5785 117.331 33.5161C116.922 32.3449 117.171 31.9033 117.165 30.9049C118.048 25.5097 116.192 20.5945 112.512 16.9209L81.8817 33.4521L82.9633 46.5337C83.1169 48.3577 81.4785 50.0665 81.5873 51.8905C82.0737 60.1209 78.7201 66.4889 77.7537 67.8649L77.0945 67.9225L101.094 80.7353L104.198 65.6761L103.853 65.7017C101.446 62.5017 100.397 59.9161 100.851 56.9529C101.126 55.1801 101.133 55.4617 107.686 56.4409C115.418 57.5929 117.574 45.9385 117.581 42.8921C119.475 42.8409 120.998 42.3609 121.728 41.8809C122.17 41.5929 123.52 40.7609 122.4 38.9689V38.9561Z"
      class="fill-brand-100"
    />
    <path
      d="M93.0817 76.441L76.0065 59.673L71.5905 63.0266C69.5105 64.5626 67.9361 66.1306 70.7777 69.625L83.8401 86.2138L93.0817 76.4474V76.441Z"
      class="fill-secondary-500"
    />
    <path
      d="M93.0305 76.4602L103.61 59.9098L107.904 64.0122C110.4 66.5018 108.909 68.633 107.962 71.3018L102.439 85.6058L93.0305 76.4538V76.4602Z"
      class="fill-secondary-500"
    />
    <path
      d="M117.267 26.6681L115.955 26.553C115.392 26.5018 114.893 26.9178 114.842 27.4874L114.496 31.3722L103.731 30.3161C110.445 27.1097 116.102 22.0217 116.102 22.0217C110.426 5.30495 91.2705 1.83615 80.6529 7.90975C70.1569 13.913 66.5793 22.8025 65.7473 31.1737C58.4065 32.7162 53.4721 38.2266 51.8913 43.1801C48.7937 52.8633 54.2593 62.201 61.6897 65.6762C69.1201 69.1578 77.9521 68.185 84.8001 63.6665C93.2865 58.0666 93.7985 44.9081 91.4625 44.1978C91.4625 44.1978 91.4625 44.1913 91.4625 44.185C85.1777 42.3866 85.1649 36.7993 85.7537 34.9242C86.2529 33.3433 87.7249 32.1018 89.3697 31.8202C91.0145 31.5386 92.5249 32.8377 94.1313 32.857C94.1505 32.857 94.1697 32.857 94.1889 32.857C94.2465 32.8698 94.3041 32.889 94.3681 32.8954L114.208 34.8474L113.722 40.3769C113.67 40.9402 114.086 41.4394 114.656 41.4906L115.968 41.6057C116.531 41.6569 117.03 41.2346 117.082 40.6713L118.221 27.7881C118.272 27.2249 117.856 26.7257 117.286 26.6746L117.267 26.6681Z"
      class="fill-brand-500"
    />
    <path
      d="M66.8672 100.499H82.6368C83.712 100.499 84.5888 101.375 84.5888 102.451V105.439H64.9216V102.451C64.9216 101.375 65.7984 100.499 66.8736 100.499H66.8672Z"
      class="fill-brand-100"
    />
  </svg>
</template>

<script>
  export default {
    name: 'LoanBroker'
  }
</script>
